<template>
  <base-material-card color="primary" icon="mdi-file-compare" inline class="px-5 py-5">
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">Adicionar Aderência AIS</div>
    </template>

    <v-form class="pt-5">
      <v-row align="center" no-gutters class="mx-4">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field id="titulo-aderencia-ais" v-model="titulo" label="Título" outlined :error-messages="errors" />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row id="periodo-imobilizacao-aderencia-ais" align="center" no-gutters class="mx-4">
        <v-col class="pb-0 pt-1" sm="5" cols="12">
          <v-menu
            v-model="menuPickerImobInicio"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider v-slot="{ errors }" rules="required|min:10">
                <v-text-field
                  v-model="dataFormattedImobInicio"
                  v-mask="'##/##/####'"
                  :error-messages="errors"
                  class="pt-0"
                  label="Data Imobilização"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @blur="dataImobInicio = parseDate(dataFormattedImobInicio)"
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="dataImobInicio"
              locale="pt-br"
              @input="
                menuPickerImobInicio = false;
                dataFormattedImobInicio = formatDate(dataImobInicio);
              "
            />
          </v-menu>
        </v-col>
        <v-col class="py-4 text-center" style="white-space: nowrap !important" sm="1" cols="12">
          <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">até</span>
        </v-col>
        <v-col class="pb-0 pt-1" sm="5" cols="12">
          <v-menu
            v-model="menuPickerImobFim"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider v-slot="{ errors }" rules="required|min:10">
                <v-text-field
                  v-model="dataFormattedImobFim"
                  v-mask="'##/##/####'"
                  :error-messages="errors"
                  class="pt-0"
                  label="Data Imobilização"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @blur="dataImobFim = parseDate(dataFormattedImobFim)"
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="dataImobFim"
              locale="pt-br"
              @input="
                menuPickerImobFim = false;
                dataFormattedImobFim = formatDate(dataImobFim);
              "
            />
          </v-menu>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    name: 'ParametrosAderenciaAis',

    mixins: [dateFormatterMixins],

    data() {
      return {
        titulo: '',
        menuPickerAis: false,
        menuPickerImobInicio: false,
        menuPickerImobFim: false,
        monthFormattedAis: '',
        monthAis: '',
        dataFormattedImobInicio: '',
        dataImobInicio: '',
        dataFormattedImobFim: '',
        dataImobFim: ''
      };
    },

    methods: {
      exportData() {
        return {
          nome: this.titulo,
          data_imobilizacao_inicio: this.dataImobInicio,
          data_imobilizacao_fim: this.dataImobFim
        };
      }
    }
  };
</script>